import React, { useEffect, useState } from 'react';

function LaunchWaitingScreen() {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
    const launchTime = new Date();
launchTime.setHours(18); // 6 PM
launchTime.setMinutes(15); // 15 minutes
launchTime.setSeconds(0);
launchTime.setMilliseconds(0);
      const diff = launchTime - now;

      if (diff <= 0) {
        clearInterval(interval);
        window.location.reload(); // 🔁 Refresh exactly at 5:34:00
        return;
      }

      const hrs = Math.floor((diff / 1000 / 60 / 60) % 24);
      const mins = Math.floor((diff / 1000 / 60) % 60);
      const secs = Math.floor((diff / 1000) % 60);

      setTimeLeft(
        `${hrs.toString().padStart(2, '0')}:${mins
          .toString()
          .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
      );
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
  style={{
    minHeight: '100vh',
    backgroundColor: '#000',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    textAlign: 'center',
  }}
>
  <img
    src="https://siddhiananta.com/static/media/sa-logo.c68b80915ffdbd8ad3ef.png"
    alt="Siddhiananta Logo"
    style={{
      width: '100%',
      maxWidth: '300px',
      height: 'auto',
      marginBottom: '30px',
    }}
  />
  <h1 style={{ fontSize: '2rem', marginBottom: '20px' }}>
    Welcome to <strong>siddhiananta.com</strong>
  </h1>
  <h3 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>🚀 Launching at 6:15 PM</h3>
  <p style={{ fontSize: '1.25rem' }}>Time Left: {timeLeft}</p>
</div>

  );
}

export default LaunchWaitingScreen;
